import {
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import {
  MatIconModule
} from '@angular/material/icon';
import {
  MatStepperModule
} from '@angular/material/stepper';
import {
  MatTabsModule
} from '@angular/material/tabs';
import {
  MatTooltipModule
} from '@angular/material/tooltip';
import {
  Router,
  RouterModule
} from '@angular/router';
import {
  ViewportScroller,
  NgClass,
  NgStyle
} from '@angular/common';

import { TFMService } from 'app/mock-api/tfm.service';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';

import { SearchComponent } from 'app/layout/common/search-widget/search.component';

@Component({
  selector: 'banner-type05',
  templateUrl: './banner-type05.component.html',
  styleUrls: ['./banner-type05.component.css'],
  standalone: true,
  imports: [
    MatIconModule,
    MatTabsModule,
    MatStepperModule,
    MatTooltipModule,
    RouterModule,
    NgClass,
    NgStyle,
    SearchComponent,
  ],
})
export class BannerType05Component implements OnInit {
  public backgroundImages: string[] = [];
  public selectedTab: string = 'flight';
  public view: any = {
    selectedTab: 'flight',
    currentImageIndex: 0,
    activeLayer: 1
  };

  constructor(
    private _tfmCartService: TFMCartService,
    private _cd: ChangeDetectorRef,
    private _router: Router,
    private _tfmService: TFMService,
    private scroller: ViewportScroller
  ) { }

  ngOnInit(): void {
    this.loadSiteAndImages();
  }

  loadSiteAndImages(): void {
    this._tfmService.getSite().then(site => {
      this.view.site = site;

      this._tfmService.filterAndSend(site._links, 'site-images').subscribe(res => {
        const images = res.content;
        images.forEach(img => {
          const imgLink = this._tfmService.getLink(img._links, 'view');
          if (imgLink?.href) {
            img.url = imgLink.href;
            this.backgroundImages.push(img.url);
          }
        });

        this.view.imageLayer1 = this.backgroundImages[0];
        this.view.activeLayer = 1;

        this.startSlideshow();
      });
    });
  }

  selectTab(tab: string): void {
    this.view.selectedTab = tab;
    this._cd.detectChanges();
  }

  onScrollToAnchor(): void {
    this.scroller.scrollToAnchor('destination-section');
  }

  tripChanged(tripData: any): void {
    this.view.trip = tripData;
    this._tfmCartService.updateTrip(tripData);
    this.redirectToResults();
  }

  searchChanged(searchData: any): void {
    this.view.search = searchData;
    this.redirectToResults();
  }

  resultChanged(): void {
    // Placeholder for future logic
  }

  redirectToResults(): void {
    if (this.view.trip && this.view.search) {
      this._router.navigateByUrl('/search-results', {
        state: {
          view: this.view,
          type: this.view.selectedTab,
        },
      });
    }
  }

  startSlideshow(): void {
    setInterval(() => {
      const nextIndex = (this.view.currentImageIndex + 1) % this.backgroundImages.length;
      const nextImage = this.backgroundImages[nextIndex];

      this.fadeToImage(nextImage);
      this.view.currentImageIndex = nextIndex;
    }, 5000);
  }

  fadeToImage(nextImage: string): void {
    const img = new Image();
    img.src = nextImage;

    img.onload = () => {
      if (this.view.activeLayer === 1) {
        this.view.imageLayer2 = nextImage;
        this.view.activeLayer = 2;
      } else {
        this.view.imageLayer1 = nextImage;
        this.view.activeLayer = 1;
      }
      this._cd.detectChanges();
    };
  }

  get currentImage(): string {
    return this.backgroundImages[this.view.currentImageIndex];
  }
}
